import { render, staticRenderFns } from "./schedule.vue?vue&type=template&id=ed8bc9d2&scoped=true&"
import script from "./schedule.vue?vue&type=script&lang=js&"
export * from "./schedule.vue?vue&type=script&lang=js&"
import style0 from "./schedule.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./schedule.vue?vue&type=style&index=1&id=ed8bc9d2&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ed8bc9d2",
  null
  
)

export default component.exports

/* chakra-loader */
const installChakraComponents = require("!../../../node_modules/chakra-loader/lib/install-components.js")
installChakraComponents(component, {CBox: require('@chakra-ui/vue').CBox})
